export class Api {

	getPosts( page, cat ) {

		return new Promise(( resolve, reject ) => {
			let queryParams = `?page=${page}${ cat ? '&categories=' + cat : '' }&per_page=12`

			let result = {
				posts: [],
				max_num_pages: 0,
				found_posts: 0,
			}

			fetch( `/wp-json/wp/v2/posts${queryParams}` )
				.then( response => {
					if ( 200 !== response.status ) {
						reject( response )
					}

					result.max_num_pages = response.headers.get('x-wp-totalpages')
					result.found_posts = response.headers.get('x-wp-total')

					return response.json()
				})
				.then( data => {
					result.posts = data
					resolve( result )
				})
			
		})
	}

	getCategories() {
		return new Promise(( resolve, reject ) => {
			fetch( `/wp-json/wp/v2/categories` )
				.then( response => {
					if ( 200 !== response.status ) {
						reject( response )
					}
					return response.json()
				})
				.then( data => {
					resolve( data.filter( cat => cat.id !== 1 ) )
				})
			
		})
	}
}